module.exports = __webpack_public_path__ + "img/user_icon_white.74b30821.svg";